(() => {
 if(customElements.get('pr-category')) return;
 class Category extends HTMLElement {
  connectedCallback(){
   if(this.controller) return;
   this.controller=new AbortController();
   this.grid=this.querySelector('[data-catalog-grid]');
   this.cards=Array.from(this.querySelectorAll('[data-catalog-item]'));
   this.kind=this.querySelector('[data-kind]');this.series=this.querySelector('[data-series]');this.sort=this.querySelector('[data-sort]');this.stock=this.querySelector('[data-stock]');
   [...new Set(this.cards.map(c=>c.dataset.seriesName))].sort((a,b)=>a.localeCompare(b,'de')).forEach(name=>{const o=document.createElement('option');o.value=name;o.textContent=name;this.series.append(o)});
   if(this.kind){[...new Set(this.cards.map(c=>c.dataset.kind))].sort().forEach(name=>{const o=document.createElement('option');o.value=name;o.textContent=name;this.kind.append(o)});this.kind.parentElement.hidden=this.kind.options.length<3;}
   this.querySelector('[data-catalog-tools]').hidden=false;
   this.addEventListener('change',()=>this.update(),{signal:this.controller.signal});
   // Pack changes update the card only. Explicit filter/sort changes rebuild the list.
   const outletNav=this.querySelector('[data-outlet-nav]');
   if(outletNav){
    outletNav.hidden=false;
    outletNav.querySelectorAll('[data-outlet-kind]').forEach(button=>{
     button.hidden=!!button.dataset.outletKind&&!this.cards.some(c=>c.dataset.kind===button.dataset.outletKind);
     button.addEventListener('click',()=>{this.kind.value=button.dataset.outletKind;this.update();},{signal:this.controller.signal});
    });
   }
   this.update();
  }
  update(){
   const y=window.scrollY;
   this.querySelectorAll('[data-outlet-kind]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.outletKind===(this.kind?.value||''))));
   let visible=0;
   this.cards.forEach(c=>{const p=c.querySelector('[data-world-card]');c.hidden=!!((this.kind?.value&&c.dataset.kind!==this.kind.value)||(this.series.value&&c.dataset.seriesName!==this.series.value)||(this.stock.checked&&p.dataset.available!=='true'));if(!c.hidden) visible++});
   const ordered=[...this.cards];
   if(this.sort.value==='featured') ordered.sort((a,b)=>(Number(b.dataset.stockRank)||0)-(Number(a.dataset.stockRank)||0));
   if(['price-asc','price-desc'].includes(this.sort.value)) ordered.sort((a,b)=>(Number(a.querySelector('[data-price]').dataset.price)-Number(b.querySelector('[data-price]').dataset.price))*(this.sort.value==='price-desc'?-1:1));
   if(this.sort.value==='discount-desc') ordered.sort((a,b)=>(Number(b.querySelector('[data-world-card]').dataset.discount)||0)-(Number(a.querySelector('[data-world-card]').dataset.discount)||0)||(Number(b.dataset.stockRank)||0)-(Number(a.dataset.stockRank)||0));
   if(ordered.some((c,i)=>this.grid.children[i]!==c)) ordered.forEach(c=>this.grid.append(c));
   let position=0;
   ordered.forEach(c=>{c.classList.toggle('prc-product--feature',!c.hidden && [4,11].includes(position%12));if(!c.hidden)position++;});
   this.querySelector('[data-count]').textContent=`${visible} ${visible===1?'Produkt':'Produkte'}`;
   this.querySelector('[data-empty]').hidden=visible>0;
   const count=this.querySelector('[data-filter-count]');if(count){const active=Number(!!this.kind?.value)+Number(!!this.series.value)+Number(this.stock.checked&&!this.stock.disabled);count.textContent=active?`(${active})`:'';}
   if(window.scrollY!==y) window.scrollTo({top:y,behavior:'instant'});
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
 }
 customElements.define('pr-category',Category);
})();
